import { render, staticRenderFns } from "./ChooseSpeciality.vue?vue&type=template&id=0a6bd938&"
import script from "./ChooseSpeciality.vue?vue&type=script&lang=ts&"
export * from "./ChooseSpeciality.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a6bd938')) {
      api.createRecord('0a6bd938', component.options)
    } else {
      api.reload('0a6bd938', component.options)
    }
    module.hot.accept("./ChooseSpeciality.vue?vue&type=template&id=0a6bd938&", function () {
      api.rerender('0a6bd938', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/debug/ChooseSpeciality.vue"
export default component.exports